export default __webpack_public_path__ + "static/media/kitchen3-after3-2048w.1361d79a.avif";